import { render, staticRenderFns } from "./DataRecordLinesTable.vue?vue&type=template&id=06916cf5"
import script from "./DataRecordLinesTable.vue?vue&type=script&lang=js"
export * from "./DataRecordLinesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports